import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { showErrorSnackbarAction } from '@root/shared/ui'

import { recentSearchesModelByNetwork } from './reatom-recent-searches'
import { deletePairFromRecentSearchesRequestAction } from './recent-searches-requests'

import type { PairAddress } from '@root/entities/pair'

export const deleteRecentSearchAction = action(
  async (ctx, req: { network: Network.Network; pairAddress: PairAddress }) => {
    const result = await ctx.schedule(() =>
      deletePairFromRecentSearchesRequestAction(ctx, {
        network: Network.toDto(req.network),
        pairAddress: req.pairAddress,
      }),
    )

    if (Result.isSuccess(result)) {
      const model = recentSearchesModelByNetwork[req.network]
      model.deleteRecentSearchAction(ctx, { pairAddress: req.pairAddress })
      return
    }

    showErrorSnackbarAction(ctx, result.failure)
  },
  'deleteRecentSearchAction',
)
